const commissionUpdate = () =>
  import('@/views/main/commission/update/update.vue')
export default {
  path: '/main/commission/update',
  name: 'commissionUpdate',
  component: commissionUpdate,
  children: []
}
